import { Line3, Vector3 } from "three";
/**
 * Функция получает вектор цели по середине между вух векторов
 * @param lineVertices Vector3[] - два вектора
 * @returns Vector3 - цели 
 */
export const getTargetPositionToMiddleLine = (lineVertices: Vector3[]) => {
    const line = new Line3(lineVertices[0], lineVertices[1]);
    const targetVector = new Vector3();
    line.getCenter(targetVector);
    return (new Vector3(targetVector.x, targetVector.y, targetVector.z));
}